import React from 'react';
import { Route } from 'react-router-dom';
import { LOCAL_AGREEMENTS } from './paths';
import LocalAgreements from 'modules/LocalAgreements/LocalAgreements';
export default function LocalAgreementsRoutes() {
  return /*#__PURE__*/React.createElement(Route, {
    path: LOCAL_AGREEMENTS,
    exact: true
  }, /*#__PURE__*/React.createElement(LocalAgreements, null));
}